/**
 * @flow
 * @relayHash f45c3b40209541e0cd92e097dea00530
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentDetail_UpdateVIPLetter_MutationVariables = {|
  input: {
    segmentId?: ?string;
    vipContext?: ?any;
    clientMutationId?: ?string;
  };
|};

export type SegmentDetail_UpdateVIPLetter_MutationResponse = {|
  +updateVipLetter: ?{|
    +segment: ?{|
      +id: string;
    |};
  |};
|};
*/


/*
mutation SegmentDetail_UpdateVIPLetter_Mutation(
  $input: UpdateVIPLetterInput!
) {
  updateVipLetter(input: $input) {
    segment {
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "UpdateVIPLetterInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentDetail_UpdateVIPLetter_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "UpdateVIPLetterInput!"
          }
        ],
        "concreteType": "UpdateVIPLetterPayload",
        "name": "updateVipLetter",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Segment",
            "name": "segment",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentDetail_UpdateVIPLetter_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "UpdateVIPLetterInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "SegmentDetail_UpdateVIPLetter_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "UpdateVIPLetterInput!"
          }
        ],
        "concreteType": "UpdateVIPLetterPayload",
        "name": "updateVipLetter",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Segment",
            "name": "segment",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation SegmentDetail_UpdateVIPLetter_Mutation(\n  $input: UpdateVIPLetterInput!\n) {\n  updateVipLetter(input: $input) {\n    segment {\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Segments/__generated__/SegmentDetail_UpdateVIPLetter_Mutation.graphql.js